document.addEventListener('DOMContentLoaded',function() {

    const cover = document.getElementById('cover');
    
    const init = function() {
        document.documentElement.removeAttribute('style');
        document.documentElement.classList.add('is-loaded');
        document.getElementsByClassName('bubble').length || document.getElementsByClassName('dots').length > 0 ? window.anims() : false;
        document.getElementsByClassName('anim').length > 0 ? window.inviewInit() : false;        
        document.documentElement.classList.add('is-ready');
        !document.body.classList.contains('page-frontline') ? window.waypoints() : false;

        setTimeout(function() {
            window.carousels();
            cover.remove();
            window.location.hash ? window.runScroll( '#'+document.getElementById(window.location.hash.substring(1)).id ) : false;
            //history.pushState("", document.title, window.location.pathname + window.location.search);
        }, 250);
    };

    window.addEventListener('load', init);    

}, false);
